import styled from 'styled-components';


export const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
`

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: .1rem;
  margin: -.1rem;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: .1rem;
`

export const Label = styled.label`
  ${(props) => props.theme.fonts.interSemibold13Auto};
  color: ${props => (props.isActive ? props.theme.colors.secondary : props.theme.colors.white100)};
  pointer-events: none;
  user-select: none;
`;

export const StyledCheckbox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2.4rem;
  height: 2.4rem;
  background: ${props => (props.checked ? 'transparent' : props.theme.colors.pink100)};
  border: ${props => (props.checked ? `.1rem solid ${props.theme.colors.darkBlue}` : '.1rem solid transparent!important')};
  border-radius: .4rem;
  transition: .3s;
`

export const Wrapper = styled.div`
  cursor: pointer;
  &:hover {
    ${StyledCheckbox} {
      ${console.log(StyledCheckbox)}
      border: .3rem solid ${(props) => props.theme.colors.darkBlue};
    }
  }

`;